import { OrdersTableSection } from '../features/orders'

export const OrdersPage = () => {
  return (
    <div className="space-y-6 py-6">
      <OrdersTableSection />
    </div>
  )
}